<!--
  - Copyright (c) 2022.
  - ISNLab
  - Owner and rewriter: Sedov A. Sergey
  - sedov.sergey@isnlab.com
  -->

<template>
  <div v-if="loading" class="loadingProgressG-cont" :class="customClass">
    <div id="loadingProgressG_1" class="loadingProgressG"></div>
  </div>
</template>

<script>
export default {
  name: "LineLoading",
  props : {
    customClass : String,
    loading : Boolean,
  }
}
</script>

<style scoped>

</style>